import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getSelectedOrder } from 'entities/Order/model/selectors/ordersSelectors';

import { TWENTY_FOUR_HOURS_MS } from '../consts';

export const useCanContactSupport = () => {
    const currentOrder = useSelector(getSelectedOrder);

    const canContactSupport = useMemo(() => {
        if (!currentOrder?.statusFirstReachedAt?.approved) {
            return false;
        }

        const approvedDate = new Date(
            currentOrder.statusFirstReachedAt.approved,
        );

        if (Number.isNaN(approvedDate.getTime())) {
            return false;
        }

        const currentDate = new Date();
        const timeDifferenceMs = currentDate.getTime() - approvedDate.getTime();

        return timeDifferenceMs >= TWENTY_FOUR_HOURS_MS;
    }, [currentOrder?.statusFirstReachedAt?.approved]);

    return { canContactSupport };
};
